<template>
  <b-modal
    id="modal-top-up-komchat-coin"
    hide-footer
    hide-header
    centered
  >
    <div class="py-1">
      <div class="text-3xl font-semibold text-center text-black">
        Top Up Komchat Coin
      </div>
      <div class="text-center my-1">
        Yuk, top up komchat coinmu untuk broadcast
      </div>
      <div class="p-1 mb-1 border rounded-md">
        <div class="text-[#333333] text-lg">
          Saldo Kompay
        </div>
        <div class="text-3xl mt-[8px] font-semibold  text-black">
          Rp{{ IDRWithoutLbl(saldo_kompay) }}
        </div>
      </div>
      <b-form @submit.prevent="handleTopup">
        <b-form-group
          id="input-group-1"
          label="Nominal*"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="nominal"
            type="text"
            placeholder="Masukkan nominal disini"
            required
            @input="formatNominal"
            @keypress="validateNumber"
          />
          <span
            v-if="nominal && getNominalValue() < 10000"
            class="text-primary text-sm"
          >*Minimal top up Rp10.000</span>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Pilih Metode Top UP*"
          label-for="input-1"
        >
          <vueSelect
            v-model="paymentMethod"
            :options="options"
            :selectable="isPaymentMethodSelectable"
            placeholder="Pilih Metode Top Up"
          >
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!paymentMethod.value"
                v-bind="attributes"
                v-on="events"
              >
            </template>
            <template #option="data">
              <div class="flex gap-2 items-center">
                <img
                  width="20"
                  :src="data.image"
                  alt=""
                > {{ data.label }}
              </div>
            </template>
          </vueSelect>
        </b-form-group>
        <div class="flex mt-1 justify-between">
          <div>
            Nominal
          </div>
          <div>
            {{ nominal || 'Rp0' }}
          </div>
        </div>
        <div
          v-show="paymentMethod.value === '2' && getNominalValue() < 500000"
          class="flex mt-1 justify-between"
        >
          <div class="text-sm text-[#828282]">
            * Fee
          </div>
          <div class="text-sm text-[#828282]">
            Rp1.000
          </div>
        </div>
        <div class="flex mt-1 justify-between">
          <div class="text-lg font-semibold text-black">
            Total Pembayaran
          </div>
          <div class="text-lg font-semibold text-black">
            Rp{{ IDRWithoutLbl(getTotalPayment()) }}
          </div>
        </div>
        <div
          v-show="isKomshipUser && qualifyIdealBalance() && idealBalance.ideal_balance !== 0"
          class=" bg-[#FFEDED] rounded-lg mt-2 mb-1 p-1"
        >
          <div>
            <span class="font-poppins text-[14px] font-medium leading-[1] align-middle">
              <b-icon
                icon="exclamation-circle"
                class="text-danger mr-[5px]"
              />
              Batas Minimal Saldo Ideal : <span class="text-[15px] font-semibold leading-[1] align-middle">{{ IDRWithoutLbl(idealBalance.ideal_balance) }}</span>
            </span>
          </div>
          <div class="mb-[5px]">
            <span class="text-[12px] font-normal leading-[1] align-middle">
              Saldo ideal diterapkan untuk menghindari saldo minus. <a href="">Pelajari lebih lanjut</a>
            </span>
          </div>
          <div class="bg-white rounded-lg p-[8px]">
            <span class="text-[12px] mb-[6px] font-normal leading-[1] align-middle">
              <b-icon
                class="mr-[2px]"
                icon="chat-left-quote"
              /> Darimana Saldo Ideal berasal?
            </span>
            <div class="mt-[5px]">
              <span class="font-poppins text-[12px] font-normal leading-[1] align-middle">
                Potensi Pendapatan Order Dikirim <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.income_order_potential) }}</span> - Ongkir Retur Ketika Sampai <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ongkir_retur_on_finished) }}</span> - Resiko Ongkir Menjadi Retur <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ongkir_risk_become_retur) }}</span> = Saldo Ideal <span class="font-poppins text-danger text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ideal_balance) }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="flex mt-2 items-center gap-2">
          <div class="w-full">
            <b-button
              block
              class="!h-[38px]"
              variant="outline-primary"
              @click="handleCancel"
            >
              Batal
            </b-button>
          </div>
          <div class="w-full">
            <b-button
              block
              variant="primary"
              type="submit"
              :disabled="isLoading || qualifyIdealBalance()"
            >
              <div class="flex justify-center gap-1 items-center">
                <div>Top Up Sekarang</div>
              </div>
            </b-button>
          </div>
        </div>
      </b-form>
      <ModalPaymentExist
        :is-custom="true"
        @cancelPayment="handleCancelTopupInvoice()"
        @continuePayment="handlePay()"
      />
    </div>
  </b-modal>
</template>

<script>
import vueSelect from 'vue-select'
import { IDRWithoutLbl } from '@/libs/currency'
import ModalPaymentExist from '../../../dashboard/modal/ModalPaymentExist.vue'
import { capitalizeWords } from '../config'
import { apiTopupKomchatCoin } from '../../../opsional/service/api.whatsapp.services'
import {
  apiCheckBill, apiTopUpWithBankTransfer, apiTopUpWithQris, apiCancelTopUpInvoice, apiCancelTopUpQrcode, apiIdealBalance,
} from '../service/api.balance.service'

export default {
  name: 'ModalTopUp',
  components: {
    vueSelect,
    ModalPaymentExist,
  },
  data() {
    return {
      saldo_kompay: this.$store.state.saldo.saldo,
      partnerId: this.$store.state.dashboard.profile.partner_id,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      IDRWithoutLbl,
      capitalizeWords,
      nominal: '',
      metode: '',
      options: [
        {
          value: '1', name: 'kompay', label: 'Kompay', image: 'https://storage.googleapis.com/komerce/assets/logo/logo.png',
        },
        {
          value: '2', name: 'bank transfer', label: 'Bank Transfer', image: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/bank.svg',
        },
        {
          value: '3', name: 'qris', label: 'QRIS - Maksimal topup Rp 500.000', image: 'https://storage.googleapis.com/komerce/assets/svg/Qris-logo.svg',
        },
      ],
      paymentMethod: [],
      checkBillData: [],
      isLoading: false,
      idealBalance: {},
    }
  },
  async mounted() {
    await this.$store.dispatch('saldo/getBalanceSummary')
    this.saldo_kompay = this.$store.state.saldo.saldo
    if (this.isKomshipUser) {
      this.getIdealBalance()
    }
  },
  methods: {
    showModal() {
      this.$bvModal.show('modal-top-up-komchat-coin')
    },
    handleCancel() {
      this.nominal = ''
      this.paymentMethod = []
      this.$bvModal.hide('modal-top-up-komchat-coin')
    },
    validateNumber(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // hanya izinkan angka dan titik
        event.preventDefault()
      }
    },
    formatNominal(value) {
      this.paymentMethod = []
      // Hapus semua karakter non-digit
      let number = value.replace(/\D/g, '')

      // Format ke Rupiah
      if (number) {
        number = parseInt(number, 10)
        this.nominal = `Rp${number.toLocaleString('id-ID')}`
      } else {
        this.nominal = ''
      }
    },
    getNominalValue() {
      if (!this.nominal) return 0
      // Hapus semua karakter non-digit
      const numericValue = this.nominal.replace(/\D/g, '')
      return parseInt(numericValue, 10) || 0
    },
    isPaymentMethodSelectable(option) {
      const nominal = this.getNominalValue()

      // Kompay: disabled jika nominal > saldo_kompay
      if (option.value === '1') {
        return nominal <= this.saldo_kompay && nominal >= 10000
      }

      // QRIS: disabled jika nominal > 500000
      if (option.value === '3') {
        return nominal <= 500000 && nominal >= 10000
      }

      if (option.value === '2') {
        return nominal >= 10000
      }

      return false
    },
    getTotalPayment() {
      const nominal = this.getNominalValue()
      // Tambahkan fee 1000 jika metode pembayaran adalah bank transfer
      if (this.paymentMethod?.value === '2') {
        if (nominal >= 500000) {
          return nominal
        }
        return nominal + 1000
      }
      return nominal
    },
    async handleTopupWithKompay() {
      const totalPayment = this.getTotalPayment()
      try {
        await apiTopupKomchatCoin(totalPayment)
        this.$toast_success({ message: 'Berhasil topup komchat coin' })
        this.handleCancel()

        // Update Kompay balance
        await this.$store.dispatch('saldo/getBalanceSummary')
        this.saldo_kompay = this.$store.state.saldo.saldo
        this.$emit('refreshSaldo')
      } catch {
        this.$toast_error({ message: 'Gagal topup kompay' })
      }
    },

    async checkBill() {
      try {
        const { data } = await apiCheckBill()
        this.checkBillData = data.data
      } catch {
        this.$toast_error({ message: 'Gagal check bill' })
      }
    },

    async handleTopupWithBankTransfer() {
      const totalPayment = this.getTotalPayment()
      try {
        const { data } = await apiTopUpWithBankTransfer(totalPayment)
        window.open(data.data.invoice_url, '_blank')
        this.$emit('refreshSaldo')
        this.handleCancel()
      } catch {
        this.$toast_error({ message: 'Gagal topup bank transfer' })
      }
    },

    async handleTopupWithQris() {
      const totalPayment = this.getTotalPayment()
      try {
        const { data } = await apiTopUpWithQris(totalPayment)
        this.$emit('handleTopupWithQris', data.data)
        this.handleCancel()
      } catch {
        this.$toast_error({ message: 'Gagal topup qris' })
      }
    },
    handlePay() {
      const {
        invoice_xendit_url, qr_xendit_id, qr_amount, qr_expire_date, qr_xendit_qrstring,
      } = this.checkBillData
      if (invoice_xendit_url) {
        window.open(invoice_xendit_url, '_blank')
        this.handleCancel()
      } else {
        const dataQris = {
          amount: qr_amount,
          id: qr_xendit_id,
          qr_string: qr_xendit_qrstring,
          expires_at: qr_expire_date,
        }
        this.$emit('handleTopupWithQris', dataQris)
        this.handleCancel()
      }
    },
    async handleCancelTopupInvoice() {
      try {
        const { invoice_xendit_id, qr_xendit_id } = this.checkBillData
        if (invoice_xendit_id) {
          await apiCancelTopUpInvoice(invoice_xendit_id, this.partnerId)
        } else {
          await apiCancelTopUpQrcode(qr_xendit_id, this.partnerId)
        }

        this.$toast_success({ message: 'Berhasil membatalkan tagihan' })
        this.$bvModal.hide('modalPaymentExist')
      } catch {
        this.$toast_error({ message: 'Gagal membatalkan tagihan' })
      }
    },

    async handleTopup() {
      try {
        this.isLoading = true
        // 1. Periksa tagihan
        await this.checkBill()
        const {
          have_active_bill,
        } = this.checkBillData
        const paymentMethod = this.paymentMethod.value
        if (have_active_bill && paymentMethod !== '1') {
          this.$bvModal.show('modalPaymentExist')
          // this.$bvModal.hide('modal-top-up-komchat-coin')
          this.isLoading = false
          return
        }

        // 4. Buat map/lookup table untuk handler pembayaran
        //    Penting: Gunakan .bind(this) atau pastikan handler Anda adalah arrow function
        //    yang didefinisikan sebagai properti kelas agar 'this' tetap merujuk ke instance kelas.
        //    Alternatif lain adalah menggunakan .call(this) saat memanggil (lihat di bawah).
        const paymentHandlers = {
          1: this.handleTopupWithKompay,
          2: this.handleTopupWithBankTransfer,
          3: this.handleTopupWithQris,
          // Tambahkan metode baru di sini dengan mudah:
          // '4': this.handleTopupWithGoPay,
        }

        // 5. Dapatkan handler yang sesuai
        const handler = paymentHandlers[paymentMethod]

        // 6. Jika handler ditemukan, jalankan. Jika tidak, tangani kasus tidak valid.
        if (handler) {
          // Panggil handler. Menggunakan .call(this) memastikan 'this'
          // di dalam fungsi handler merujuk ke instance kelas yang benar.
          await handler.call(this)
        } else {
          console.error('Metode pembayaran tidak valid:', paymentMethod)
          // Tampilkan pesan error ke pengguna
        }
        this.isLoading = false
      } catch (error) {
        // 7. Tambahkan penanganan error umum
        console.error('Terjadi kesalahan selama proses top-up:', error)
        // Tampilkan pesan error umum ke pengguna
      }
    },
    async getIdealBalance() {
      try {
        const { data } = await apiIdealBalance(this.partnerId)
        this.idealBalance = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mendapatkan saldo ideal' })
      }
    },
    qualifyIdealBalance() {
      if (this.isKomshipUser) {
        const nominal = this.getNominalValue()
        const kompay = this.saldo_kompay
        const idealBalance = this.idealBalance.ideal_balance
        const kompayRemaining = kompay - nominal
        if (kompayRemaining < idealBalance && this.paymentMethod?.value === '1') {
          return true
        }
        return false
      }

      const nominal = this.getNominalValue()
      const currentKompayBalance = this.saldo_kompay
      const requiredIdealBalance = this.idealBalance?.ideal_balance || 0
      const balanceAfterTopup = currentKompayBalance - nominal
      return balanceAfterTopup < requiredIdealBalance
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
